<template>
  <router-view />
</template>

<script>
import { api } from 'boot/axios'
import { Notify } from 'quasar'
import getError from 'src/utils/errors-catalog.js'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'App',
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const router = useRouter()

    api.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response.status == 401) {
          store.dispatch('auth/clear')
          router.push({ name: 'login' })
        }
        const fields =
          error.response.data.message && error.response.data.message.fields
            ? error.response.data.message.fields
            : error.response.data.fields
            ? error.response.data.fields
            : []
        Notify.error(
          getError(t, error.response.status, error.response.data.code, fields)
        )
        return Promise.reject(error)
      }
    )
  }
}
</script>
